/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ConnectionAction from './ConnectionAction/index'
import Description from './Description/index'
import LearnMore from './LearnMore/index'
import LearnMoreAction from './LearnMoreAction/index'
import Link from './Link/index'
import Logo from './Logo/index'
import MaybeRedirectToInstall from './MaybeRedirectToInstall/index'
import Name from './Name/index'
import Problem from './Problem/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function App({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App"
  
}) {
let appIdValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'id',
})
let tabSelectedInstallAppIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.install_app_id',
})
let aggregateData = fromAggregate.equals(appIdValueData, tabSelectedInstallAppIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="App.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-hJL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-hJL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-hJL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-hJL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-hJL': dtColorsNeutral300,'--pt-7-hJL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-8-hJL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-9-hJL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-hJL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bw-6-hJL': aggregateData ? typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs : "1px",'--mt-11-hJL': aggregateData ? typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-12-hJL': aggregateData ? typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL : "0px"}}
 className={`views-block ${styles.Horizontal}`}
>
<Logo
  viewPath={`${viewPath}/Logo`}
/>
<div
  data-testid="App.Vertical"
  data-view-path={viewPath}
 style={{'--ml-13-hJL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="App.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Link
  viewPath={`${viewPath}/Link`}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
<Problem
  viewPath={`${viewPath}/Problem`}
/>
</div>
<Description
  viewPath={`${viewPath}/Description`}
/>
<div
  data-testid="App.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-11-hJL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<ConnectionAction
  viewPath={`${viewPath}/ConnectionAction`}
/>
<LearnMoreAction
  viewPath={`${viewPath}/LearnMoreAction`}
/>
</div>
<LearnMore
  viewPath={`${viewPath}/LearnMore`}
/>
</div>
</div>
<MaybeRedirectToInstall
  viewPath={`${viewPath}/MaybeRedirectToInstall`}
/>
{children}
</React.Fragment>)
}